import { fetchWithTokenRefresh } from './AuthActions';
import {
  user_shoutouts_returned,
  user_profile_opened,
  all_profile_shoutouts_loaded,
  profile_shoutouts_requested,
  change_filter
} from './types';
import env from '../globals/environment';
import { mapShoutoutToUsers } from './ShoutoutsActions';

const LIMIT = 20;

export const openProfile = (id) => {
  return dispatch => {
    dispatch({ type: user_profile_opened, payload: id });
    dispatch(getShoutoutsForUser());
  };
};

export const filterShoutouts = (shoutoutFilter, id, after) => {
  let filter;
  switch (shoutoutFilter) {
    case 'Received':
      filter = `${env.backendUrl}/shoutouts?limit=${LIMIT}&recipient=${id}&after=${after}`;
      break;
    case 'Sent':
      filter = `${env.backendUrl}/shoutouts?limit=${LIMIT}&sender=${id}&after=${after}`;
      break;
    case 'Sent & Received':
      filter = `${env.backendUrl}/shoutouts?limit=${LIMIT}&sender=${id}&recipient=${id}&after=${after}`;
      break;
    default:
      break;
  }
  return filter;
};

export const getShoutoutsForUser = () => {
  return async (dispatch, getState) => {
    const { authStore, usersStore, profile } = getState();
    const { allShoutoutsLoaded, shoutoutsLoading, after, id, shoutoutFilter } = profile;

    try {
      if (!shoutoutsLoading && !allShoutoutsLoaded) {
        dispatch({ type: profile_shoutouts_requested });

        let endpt = filterShoutouts(shoutoutFilter, id, after);
        const { headers } = authStore;
        const { users } = usersStore;

        const response = await fetchWithTokenRefresh(endpt, { headers })(dispatch);

        if (!response.ok) throw new Error('Could not get shoutouts from api');
        else {
          const data = await response.json();
          const { after, shoutouts } = data;

          if (shoutouts.length < LIMIT) {
            dispatch({ type: all_profile_shoutouts_loaded });
          }

          dispatch({
            type: user_shoutouts_returned,
            payload: {
              after,
              shoutouts: shoutouts.map(shoutout => mapShoutoutToUsers(shoutout, users))
            }
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const updateShoutoutFilter = (filter) => {
  return (dispatch) => {
    dispatch({ type: change_filter, payload: filter });
    dispatch(getShoutoutsForUser());
  };
};


// WEBPACK FOOTER //
// ./src/actions/ProfileActions.js